let REVIEW_MODE_WINDOW = window.parent;

interface IPostMessageData {
  type: string;
  data: string;
}

export function reviewToolPostMessage(postMessageData: IPostMessageData) {
  if (REVIEW_MODE_WINDOW) {
    REVIEW_MODE_WINDOW?.postMessage(postMessageData, '*');
  }
}

export function reviewToolPostMessageOnMessage(
  fN: (e: { [key: string]: any }) => void
): () => void {
  window.addEventListener('message', fN);

  return () => {
    window.removeEventListener('message', fN);
  };
}
